import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasCostoventaagListaComponent {
  constructor(PolizasExternasCostoventaAg, $filter, $file) {
    this.$filter = $filter
    this.verificarCadena = $filter('rPad')
    this.$file = $file
    this.PolizasExternasCostoventaAg = PolizasExternasCostoventaAg
  }

  $onInit() {
    this.promise = this.PolizasExternasCostoventaAg.get(this.busqueda)
      .then((resolve) => {
        this.data = this.$filter('orderBy')(resolve.data, ['nombre'])
        this.resultados = [].concat(this.data)
      })
  }

  descargar() {
    let texto = this.codificar(1)
    let fecha = this.$filter('date')(new Date(), 'yyyyMMdd')
    let nombre = 'PolizaCostoventa_' + fecha + '.txt'
    let blob = new File([texto], nombre, { type: 'text/plain' })
    this.$file.saveAs(blob, nombre)
  }

  codificar(inicioPoliza) {
    let cadA = 'P  AAAAMMDD    3      JJJJ 1 0          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\r\n'
    let cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \r\n'

    return this.data.reduce((cadena, sucursal, index) => {
      const taquilla = sucursal.ventas.some((venta) => venta.familia_id === 'TAQUILLA');

      if (taquilla) return ''

      cadena += cadA
        .replace('AAAAMMDD', this.$filter('date')(this.busqueda.fechaInicial, 'yyyyMMdd'))
        .replace('JJJJ', ('000' + (inicioPoliza + index)).slice(-4))
        .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', this.verificarCadena('Costo de venta ' + sucursal.nombre, 60))

      cadena += cadB
        .replace('CCCCCCCCCCCCCCCC', this.verificarCadena(sucursal.cuenta_contable.replace(/-/g, ''), 16))
        .replace('ZZZZZZZZZZZZZZZ', this.verificarCadena(this.eliminarDiacriticos(sucursal.nombre), 15))
        .replace('*', '0')
        .replace('YYYYYYYYY', this.verificarCadena(parseFloat(sucursal.total).toFixed(2), 9))
        .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', this.verificarCadena(this.eliminarDiacriticos(sucursal.nombre), 43))

      sucursal.ventas.forEach((venta) => {
        if (venta.familia_id !== 'PATROCINIO') {
          if (venta.costo_iva_venta !== 0 && venta.familia_id !== 'PAQUETERIA') {
            cadena += cadB
              .replace('CCCCCCCCCCCCCCCC', this.verificarCadena(venta.familia.cuenta_contable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', this.verificarCadena(this.eliminarDiacriticos(venta.familia.nombre), 15))
              .replace('*', '1')
              .replace('YYYYYYYYY', this.verificarCadena((venta.costo_iva_venta).toFixed(2), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', this.verificarCadena(sucursal.nombre, 43))
          }
        }
      })

      return cadena
    }, '')
  }

  eliminarDiacriticos(texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  filtrar() {
    this.resultados = this.$filter('filter')(this.data, this.filtro)
  }
}

module.component('contabilidadPolizasexternasCostoventaagLista', {
  controller: ContabilidadPolizasexternasCostoventaagListaComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/costoventaag/lista/component.js